<template>
  <f7-page>
    <f7-navbar title="開店申請" back-link="back"></f7-navbar>

    <f7-list no-hairlines-md>
      <f7-list-item title="* 為必填" style="color: red;"/>
      <f7-list-item ref="id">
        <f7-label :style="{ color: storeData.id && storeData.id.match(storeIdRegex) ? 'rgba(0, 0, 0, 0.65)' : 'red' }">餐廳 ID (最長30字，會成為網址的一部分) *</f7-label>
        <f7-input type="text" placeholder="只接受a-z, 0-9, 底線(_), 連接號(-), 點(.)" :value="storeData.id" @input="setEditorStoreData('id', $event.target.value)" @focus="onFocus('id')" clear-button />
      </f7-list-item>
      <f7-list-item ref="name">
        <f7-label :style="requiredStyle('name')">餐廳名稱 *</f7-label>
        <f7-input type="text" placeholder="公開顯示在網頁上" :value="storeData.name" @input="setEditorStoreData('name', $event.target.value)" @focus="onFocus('name')" clear-button />
      </f7-list-item>
      <f7-list-item ref="branch">
        <f7-label>分店名稱</f7-label>
        <f7-input type="text" placeholder="若是只有一間分店則空白" :value="storeData.branch" @input="setEditorStoreData('branch', $event.target.value)" @focus="onFocus('branch')" clear-button />
      </f7-list-item>
      <f7-list-item ref="registeredOwner">
        <f7-label :style="requiredStyle('registeredOwner')">餐廳登記負責人姓名 *</f7-label>
        <f7-input type="text" placeholder="本欄用於正式資訊" :value="storeData.registeredOwner" @input="setEditorStoreData('registeredOwner', $event.target.value)" @focus="onFocus('registeredOwner')" clear-button />
      </f7-list-item>
      <f7-list-item ref="phoneNumber">
        <f7-label :style="requiredStyle('phoneNumber')">負責人手機號碼 (緊急聯絡) *</f7-label>
        <f7-input type="text" placeholder="ex. 0912-345-678" :value="storeData.phoneNumber" @input="setEditorStoreData('phoneNumber', $event.target.value)" @focus="onFocus('phoneNumber')" clear-button />
      </f7-list-item>
      <f7-list-item ref="email">
        <!-- <f7-label :style="requiredStyle('email')">聯絡人 Email *</f7-label> -->
        <f7-label :style="{ color: (storeData.email && storeData.email.match(emailRegex) ) ? 'rgba(0, 0, 0, 0.65)' : 'red' }">聯絡人 Email *</f7-label>

        <f7-input type="text" placeholder="聯絡方式" :value="storeData.email" @input="setEditorStoreData('email', $event.target.value)" @focus="onFocus('email')" clear-button />
      </f7-list-item>
    </f7-list>
    <f7-button v-if="isValid()" raised fill style="margin: 20px;" @click="createNewStore">送出</f7-button>
  </f7-page>
</template>

<script>
import Vue from 'vue'
import { storeClient } from '@/service/apiClients'

export default {
  data () {
    return {
      storeData: {},
      storeIdRegex: /^[0-9a-z._-]{3,30}$/,
      emailRegex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    }
  },
  methods: {
    onFocus (field) {
      this.$refs[field].$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    isValid () {
      return this.storeData.id &&
        this.storeData.id.match(this.storeIdRegex) &&
        this.storeData.name &&
        this.storeData.phoneNumber &&
        this.storeData.registeredOwner &&
        this.storeData.email &&
        this.storeData.email.match(this.emailRegex)
    },
    requiredStyle (field) {
      return { color: this.storeData[field] ? 'rgba(0, 0, 0, 0.65)' : 'red' }
    },
    setEditorStoreData (field, value) {
      Vue.set(this.storeData, field, value)
    },
    async createNewStore () {
      if (this.isValid()) {
        await storeClient.post('/createNewStore', this.storeData)
        this.$f7router.navigate('/')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dirty {
  animation: blink 1s ease-in-out infinite alternate;
}
</style>
